import { render, staticRenderFns } from "./PhotosList.vue?vue&type=template&id=6cd87389&"
import script from "./PhotosList.vue?vue&type=script&lang=js&"
export * from "./PhotosList.vue?vue&type=script&lang=js&"
import style0 from "./PhotosList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports